import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject'

export default new BehaviorSubject({
    record: {},
    contextMenuId: '',
})
